module.exports = __webpack_public_path__ + "static/media/add.6e647fb8.svg";